import Model from './Model'
export default class Workstation extends Model {

    baseURL() {
        return `${window.App.api_endpoint}/api`
    }

    resource()
    {
        return 'workstations'
    }

    get vat_no() {
        return this.data?.company_vat
    }

    get full_address() {
        return `${this.data.company_address} ${this.data.company_address_no}, ${this.data.company_city}`
    }
}
